import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearAuditChanged } from '../../redux/reducer/coreScriptReducer';
import { RootState } from '../../redux/Store';
import { contextPostMessageBack } from '../../constants';

export const handleSendMessageStatus = (data: {
  SubmitComplete: boolean; //script is complete script was completed with all required fields
  Followup: boolean; //Audit Results Sending on Followup
  AuditSaved: string | number | undefined; //Relevant to submitting audit results context
  Canceled: boolean; //Canceled close without saving
  Context: string;
  ContextKey: string;
  ContextId: string;
}) => {
  const supportMessageBack = contextPostMessageBack[data.Context] ?? false;
  if (!data || !data.Context || !supportMessageBack) {
    return;
  }
  //These context are spending status back to spiglass iframe
  const targetWindow = window.parent;
  if (targetWindow) {
    const hostname = globalThis.location.hostname;
    // Replace 'safeview' with 'spiglass' in the hostname
    const targetHostname = hostname.replace('safeview', 'spiglass');

    targetWindow.postMessage(data, `https://${targetHostname}`);
  }

  return;
};

const useContextQueryObj = () => {
  return useSelector((state: RootState) => state.contextId.queryObj);
};
export const useSinglePostMessage = (stateData: any) => {
  const hasSentMessage = useRef(false);
  const prevAuditChanged = useRef(stateData?.AuditChanged);
  const dispatch = useDispatch();
  const queryObj = useContextQueryObj();

  useEffect(() => {
    const supportMessageBack =
      contextPostMessageBack[queryObj?.context] ?? false;
    if (!supportMessageBack) {
      return;
    }

    // Check if AuditChanged has changed
    if (stateData?.AuditChanged !== prevAuditChanged.current) {
      // Update the ref to the current value
      prevAuditChanged.current = stateData?.AuditChanged;

      if (stateData?.AuditChanged && !hasSentMessage.current) {
        handleSendMessageStatus({
          Canceled: false,
          SubmitComplete: false,
          AuditSaved: stateData?.AuditSaved,
          Followup: stateData?.Followup,
          Context: `${queryObj?.context}`,
          ContextId: `${queryObj?.id}`,
          ContextKey: `${queryObj?.key}`,
        });
        dispatch(clearAuditChanged());
        hasSentMessage.current = true;
      }

      if (!stateData?.AuditChanged) {
        hasSentMessage.current = false;
      }
    }
  }, [
    stateData?.AuditChanged,
    dispatch,
    stateData,
    queryObj?.context,
    queryObj?.id,
    queryObj?.key,
  ]);
};

export const cancelPostMessage = (context: string, key: string, id: string) => {
  const supportMessageBack = contextPostMessageBack[context] ?? false;
  if (!supportMessageBack) {
    return;
  }

  handleSendMessageStatus({
    Canceled: true,
    SubmitComplete: false, //relevant to saving
    AuditSaved: undefined, //Relevant to submit audited context only
    Followup: false, //Relevant to submit audited context only
    Context: context,
    ContextId: id,
    ContextKey: key,
  });
};
// export default useSinglePostMessage;

// export default handleSendMessageStatus;
